// 退款单（销售合同下的业务单据页面配置）
// 【P13-R2】老系统对齐：
// 01 name 自动生成（客户名_退款单_yymmddHis / method=3 客户名_转款单_yymmddHis），表单不再填名称
// 02 客户/收款单位(签约公司)/商机 由后端从销售合同自动带出
// 03 关联合同=本销售合同产生的财务合同（选项 mixin 加载，留空后端自动反查最新一条）
// 04 三种退款方式：1=退款到余额 2=退款给客户 3=余额转到其他销售合同
//    method=1/3 提交即自动审批通过（老系统 autoBalance 口径）；method=2 需财务人工审批（showIf 指定审批人）
// 07 method=3 显示「转移到」下拉（同客户其他非充值合同 top5，最新创建在前）
// 08 金额校验后端对齐老系统 BC 25163（充值合同拦截/余额支付部分不退/余额充足/范围校验）
// 【P14】退款单号纯自动生成（去掉手填）；去掉退款原因输入；新增退款凭证图片上传（attachment_image）
import {
  getContractRefundListData,
  saveContractRefundData,
  saveContractRefundEditData,
  saveContractRefundDeleteData
} from "../../api/api.js";

export default {
  key: "refund",
  title: "退款单",
  short: "退款单",
  icon: "refund-o",
  listFn: getContractRefundListData,
  saveFn: saveContractRefundData,
  editFn: saveContractRefundEditData,
  deleteFn: saveContractRefundDeleteData,
  // 卡片标题：退款单号 · 金额 · 单据名称（老系统自动生成）
  titleFields: ["refund_no", "amount", "name"],
  fields: [
    /* 【P354】所属客户改为**锁定只读**（用户 10-14 需求，与会议室订单/支付单同口径）。
       原来退款单表单**完全没有客户字段**（只有列表/详情用的 `customer_name` label），
       用户看不到「客户被锁定」这件事。现加一个 readonly 的 select：
       红星 + 锁图标、不弹选择器，值由 contractDetailMixin.openAdd 从合同继承。 */
    {
      prop: "customer_sn", label: "所属客户", type: "select", required: true, group: "关联信息",
      options: [], placeholder: "自动继承销售合同客户", nameKey: "customer_name",
      readonly: true
    },
    // 【P14】退款单号：纯自动生成（后端 _csxSerial，与其他单号同原理），表单不再暴露
    { prop: "amount", label: "金额", type: "number", required: true, group: "退款信息", placeholder: "请输入退款金额" },
    {
      // 【P13-R2】退款去向：老系统 refundPayment_method 三方式
      prop: "refundPayment_method", label: "退款去向", type: "select", required: true, group: "退款信息",
      placeholder: "请选择退款去向",
      options: [
        { label: "退款到余额", value: 1 },
        { label: "退款给客户", value: 2 },
        { label: "余额转到其他销售合同", value: 3 }
      ]
    },
    {
      // 【P13-R2】关联合同：本销售合同产生的财务合同（留空自动带出最新一条）
      prop: "contracts_sn", label: "关联合同", type: "select", group: "退款信息",
      placeholder: "本合同的财务合同（留空自动带出）", options: []
    },
    {
      // 【P13-R2】method=3 才显示：余额转移到其他销售合同（同客户非充值合同 top5）
      prop: "to_order_sn", label: "转移到", type: "select", required: true, group: "退款信息",
      placeholder: "请选择要转到的销售合同", options: [],
      showIf: form => Number(form.refundPayment_method) === 3
    },
    {
      // 【P13-R2】method=2 财务人工审批需指定审批人（默认陈凯蕾 466）；method=1/3 自动通过无需选择
      prop: "approval_user_id", label: "审批人", type: "select", group: "审批",
      options: [], placeholder: "财务部门人员 · 默认陈凯蕾",
      showIf: form => Number(form.refundPayment_method) === 2
    },
    // ===== 凭证 =====
    // 【P14】退款凭证：图片上传（落 attachment_image，与支付单凭证同机制 client/orderPaymentUpload）
    {
      prop: "attachment_image", label: "退款凭证", type: "upload", group: "凭证",
      maxCount: 1, accept: "image/*"
    },
    { prop: "remark", label: "备注", type: "textarea", group: "凭证", placeholder: "选填" },
    // ===== 关联信息 =====
    // 【P18】后端挂载的展示字段（type=label：仅列表卡片与详情展示，不进表单）
    { prop: "customer_name", label: "客户名称", type: "label", group: "关联信息" },
    { prop: "opportunitie_name", label: "商机", type: "label", group: "关联信息" },
    { prop: "order_name", label: "销售合同", type: "label", group: "关联信息" },
    { prop: "fc_name", label: "财务合同", type: "label", group: "关联信息" },
    { prop: "to_order_name", label: "转入合同", type: "label", group: "关联信息" }
    // 名称/收款单位：后端自动带出；状态：流程控制（0审核中/1已退款/2已驳回/3草稿），表单不暴露
  ]
};



// WEBPACK FOOTER //
// ./src/pages/contract/Refunds.js